
import { Helmet } from "react-helmet";

const HebrewPrivacyPage = () => {
  return (
    <div className="container mx-auto px-4 py-8" dir="rtl">
      <Helmet>
        <title>מדיניות פרטיות - Lainasampo.fi</title>
        <meta name="description" content="מדיניות הפרטיות לשירות השוואת הלוואות Lainasampo.fi" />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">מדיניות פרטיות</h1>
        
        <div className="prose prose-blue max-w-none">
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. בקר נתונים</h2>
          <p>
            חברת Pulaton Oy אחראית על הפרטיות של שירות Lainasampo.fi.
            <br />
            מספר עסק: FI12345678
            <br />
            כתובת: רחוב לדוגמה 123, 00100 הלסינקי, פינלנד
            <br />
            אימייל: tietosuoja@lainasampo.fi
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. מידע שנאסף</h2>
          <p>
            אנו אוספים את המידע הבא ממשתמשים לצורך עיבוד הצעות הלוואה:
          </p>
          <ul className="list-disc pl-5 mb-4 mr-5 text-right">
            <li>שם ופרטי התקשרות (כתובת אימייל, מספר טלפון)</li>
            <li>מידע זיהוי אישי</li>
            <li>מידע על תעסוקה והכנסה</li>
            <li>מידע הקשור להלוואה (סכום רצוי, מטרה, תקופה)</li>
            <li>מידע פיננסי (הלוואות קיימות, הוצאות)</li>
            <li>מידע טכני (כתובת IP, סוג דפדפן, מידע על מכשיר)</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. שימוש במידע</h2>
          <p>
            אנו משתמשים במידע שלך למטרות הבאות:
          </p>
          <ul className="list-disc pl-5 mb-4 mr-5 text-right">
            <li>לעיבוד בקשת ההלוואה שלך</li>
            <li>לבקשת הצעות הלוואה מהמוסדות הפיננסיים השותפים שלנו</li>
            <li>לתקשורת איתך לגבי בקשתך</li>
            <li>לשיפור השירות וחוויית המשתמש שלנו</li>
            <li>למילוי חובותינו החוקיות</li>
            <li>לניתוח סטטיסטי ופיתוח שירות</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. גילוי מידע</h2>
          <p>
            אנו מגלים את המידע שלך ל:
          </p>
          <ul className="list-disc pl-5 mb-4 mr-5 text-right">
            <li>המוסדות הפיננסיים השותפים שלנו למטרת מתן הצעות הלוואה</li>
            <li>ספקי שירות המסייעים לנו בהפעלת האתר שלנו ובאספקת השירותים שלנו</li>
            <li>רשויות כאשר נדרש על פי חוק</li>
          </ul>
          <p>
            מידע אינו נחשף למטרות שיווק ללא הסכמתך המפורשת.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. אבטחת נתונים</h2>
          <p>
            אנו מיישמים אמצעים טכניים וארגוניים מתאימים כדי להגן על המידע האישי שלך מפני גישה, 
            גילוי, שינוי והשמדה בלתי מורשים.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. אחסון נתונים</h2>
          <p>
            אנו מאחסנים את המידע שלך כל עוד נדרש כדי להשיג את המטרות שלשמן הוא נאסף, לעמוד 
            בהתחייבויות חוקיות, או להגן על האינטרסים הלגיטימיים שלנו.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. זכויותיך</h2>
          <p>
            יש לך זכות ל:
          </p>
          <ul className="list-disc pl-5 mb-4 mr-5 text-right">
            <li>גישה לנתונים האישיים שלך</li>
            <li>תיקון נתונים אישיים לא מדויקים</li>
            <li>בקשת מחיקת הנתונים האישיים שלך</li>
            <li>הגבלת או התנגדות לעיבוד הנתונים האישיים שלך</li>
            <li>ניידות נתונים</li>
            <li>משיכת הסכמתך בכל עת</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. פרטי יצירת קשר</h2>
          <p>
            אם יש לך שאלות כלשהן לגבי מדיניות הפרטיות שלנו או כיצד אנו מטפלים בנתונים האישיים שלך, 
            אנא צור איתנו קשר ב:
            <br />
            אימייל: tietosuoja@lainasampo.fi
            <br />
            טלפון: +358 40 123 4567
          </p>
        </div>
      </div>
    </div>
  );
};

export default HebrewPrivacyPage;
